import React from 'react';
import Row from "react-bootstrap/Row";

const noRecordsRequired = () => {
    return (
        <div>
            You have successfully registered in the Sara Schenirer Dual Credit Program.
            <br />
            Please check your email for a welcome letter and an automated receipt.<br />
            {/*Once your payment has been successfully processed, you will receive an email confirmation that your registration is complete.*/}
        </div>
    );
}

const recordsRequired = () => {
    return (
        <div>
            Thank you for registering for the Sara Schenirer Dual Credit Program.   <br />
            As you did not pre-register, we need to review your transcript.  <br />
            Once we have confirmed that you have a sufficient GPA to join the program, you will receive an email that your registration is complete.
        </div>
    );
}
const recordsRequiredSome = () => {
    return (
        <div>
            Thank you for registering for the Sara Schenirer Dual Credit Program.   <br />
            In order to process your registration, we need your high school to send us a copy of your transcript for review.  <br />
            Please reach out to your high school to send your transcript to <a href="mailto:hstranscripts@sarasch.com" target="_blank">hstranscripts@sarasch.com</a> ASAP.   <br />
            Once we have confirmed that you have a sufficient GPA to join the program, you will receive an email confirmation that your registration is complete.


        </div>
    );
}

const ThankYou = (props) => {
    const { formData } = props;

    return (
        <>
            <Row className="mb-3 text-start">
                {/*<h3 className="text-center">  Registration Complete</h3>*/}
                <div> {formData.firstName} {formData.lastName},</div>
                {props.returningStatus === 'approved' ? (
                    noRecordsRequired()
                ) : (
                    formData.school.requireRecord == 'Yes all' ? (
                        recordsRequired()
                    ) : formData.school.requireRecord == 'Yes some' ? (
                        recordsRequiredSome()
                    ) : (
                        noRecordsRequired()
                    )
                )}
            </Row>
        </>
    );
}

export default ThankYou;